export default __webpack_public_path__ + "static/media/mockup3.0bb5923a.png";